
import React, { Component } from 'react';

import { DetailProvider, DetailContext } from 'core/DetailProvider';
import { FormContext, FormProvider } from 'core/FormProvider';
import { YellowButton } from 'ui/Button';
import { SemiTrailerForm } from './Form';
import Layout from 'components/Dashboard/Layout';


export default class SemiTrailerDetail extends Component {

  onLoaded = (item) => {
    document.title = `Полуприцеп ${item.number || item.id}`;
  };

  render() {
    const { match } = this.props;
    return (
      <DetailProvider
        url={`fleet/trailer/${match.params.id}`}
        onLoaded={(item) => this.onLoaded(item)}
      >
        <DetailContext.Consumer>
          {detailContext => {
            let { item } = detailContext;
            return (
              <FormProvider
                url={item.meta.url}
                postSaveMessage={'Полуприцеп обновлён'}
                postSave={(item) => detailContext.updateItem(item)}
                item={item}
              >
                <FormContext.Consumer>
                {formContext => {
                  const { loading } = formContext;
                  return (
                    <Layout>
                      <Layout.Header
                        title={'Редактирование полуприцепа'}
                        backUrl={'/semi_trailer'}
                      />

                      <Layout.ContentSimple>
                        <SemiTrailerForm />

                        <div className={'mt-30'}>
                          <YellowButton
                            onClick={(e) => formContext.handleSubmit(e)}
                            disabled={loading}
                            size={'large'}
                          >
                            Обновить полуприцеп
                          </YellowButton>
                        </div>
                      </Layout.ContentSimple>
                    </Layout>
                  )
                }}
                </FormContext.Consumer>
              </FormProvider>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
